import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const RoyalTemple = {
  id: "133",
  name: "Royal Temple",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Royal_Temple",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Royal_Temple',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.RANGED_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        2.0, 2.0, 2.5, 2.5, 2.5, 3.0, 3.0, 3.0, 3.5, 3.5,
        3.5, 3.5, 4.0, 4.0, 4.0, 4.5, 4.5, 4.5, 5.0, 5.0,
        5.0, 5.0, 5.5, 5.5, 5.5, 6.0, 6.0, 6.0, 6.5, 6.5,
        6.5, 6.5, 7.0, 7.0, 7.0, 7.5, 7.5, 7.5, 8.0, 8.0,
        8.0, 8.0, 8.5, 8.5, 8.5, 9.0, 9.0, 9.0, 9.5, 9.5,
        9.5, 9.5, 10.0, 10.0, 10.0, 10.5, 10.5, 10.5, 11.0, 11.0
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          if (level <= 4) return 1;
          if (level <= 9) return 2;
          if (level <= 14) return 3;
          if (level <= 19) return 4;
          if (level <= 24) return 5;
          if (level <= 29) return 6;
          if (level <= 34) return 7;
          if (level <= 39) return 8;
          if (level <= 44) return 9;
          if (level <= 49) return 10;
          if (level <= 54) return 11;
          if (level <= 59) return 12;
          return 13;
        }
      ).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new CultureBonus(
      CultureAmount.asCallbackWithLevelAndEra(
        (level, era) => {
          const eraData = {
            stoneAge: { init: 85, multiplier: 5, level1: 48 },
            bronzeAge: { init: 102, multiplier: 6, level1: 64 },
            minoanEra: { init: 119, multiplier: 7, level1: 80 },
            classicGreece: { init: 136, multiplier: 8, level1: 96 },
            earlyRome: { init: 153, multiplier: 9, level1: 112 },
            romanEmpire: { init: 170, multiplier: 10, level1: 128 },
            byzantineEra: { init: 187, multiplier: 11, level1: 144 },
            ageOfTheFranks: { init: 204, multiplier: 12, level1: 160 },
            feudalAge: { init: 221, multiplier: 13, level1: 176 },
            iberianEra: { init: 238, multiplier: 14, level1: 192 },
            kingdomOfSicily: { init: 255, multiplier: 15, level1: 208 },
            highMiddleAges: { init: 272, multiplier: 16, level1: 224 },
            earlyGothicEra: { init: 289, multiplier: 17, level1: 240 },
            lateGothicEra: { init: 0, multiplier: 0, level1: 0 },
          };

          if (eraData[era] === undefined) {
            console.error(`Unknown era ${era} for building effect on ${RoyalTemple.name}`);
            return 0;
          }

          if (level === 1) {
            return eraData[era].level1;
          }

          return eraData[era].init + eraData[era].multiplier * (level - 2);
        }
      ),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 4,
      ]),
    ),
  ]),
};

export default RoyalTemple;
